module.exports = __webpack_public_path__ + "assets/img/2.043b6515.gif";